// extracted by mini-css-extract-plugin
export default {"popoverContent":"style_popoverContent__+Gp7N"};